import React, { useContext } from "react";
import currentUserContext from "../context/builderData";
import Provider from "./provider";
import Operator from "./operator";

const Selector = (props) => {
  const context = useContext(currentUserContext);
  const Component = context.roles.name === "seller" ? Operator : Provider;
  return <Component {...props} />;
};

export default Selector;
